import { intervalToDuration } from "date-fns";
import AuthService from "../Services/AuthService";
import constant from "./Constant";
const getElement = (item) => {
    let el = document.querySelector(item);
    return el;
}

let audioContext;

export const getAudioContext = () => {
    if (!audioContext || audioContext.state === "closed") {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        audioContext = new AudioContext();
    }
    return audioContext;
};

const Helpers = {
    ApplyFixedScroll() {
        let targetElement = document.querySelector(".MuiDataGrid-virtualScroller")
        if (targetElement) {
            let fixedElements = getElement("header").clientHeight + getElement(".MuiDataGrid-columnHeaders").clientHeight + getElement(".MuiDataGrid-footerContainer").clientHeight + 20;
            let fixedSections = document.querySelectorAll("[data-fixed-section]");
            // Count Fixed Heights
            fixedSections.forEach(element => {
                fixedElements = fixedElements + element.clientHeight
            });
            targetElement.style.height = `calc(100vh - ${fixedElements}px)`;
            targetElement.style.overflowY = "auto";
        }
    },
    // calculate estimated time between two locations
    EstimateDrivingTime(lat1, lon1, lat2, lon2, averageSpeed) {
        // Function to calculate the Haversine distance between two points
        function haversineDistance(lat1, lon1, lat2, lon2) {
            const R = 6371; // Radius of the Earth in kilometers
            const dLat = degreesToRadians(lat2 - lat1);
            const dLon = degreesToRadians(lon2 - lon1);
            const a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(degreesToRadians(lat1)) * Math.cos(degreesToRadians(lat2)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            const distance = R * c; // Distance in kilometers
            return distance;
        }

        // Function to convert degrees to radians
        function degreesToRadians(degrees) {
            return degrees * (Math.PI / 180);
        }

        // Calculate the Haversine distance
        const distance = haversineDistance(lat1, lon1, lat2, lon2);

        // Calculate the estimated driving time
        const time = distance / averageSpeed; // Time in hours

        // Return the time in hours and minutes
        const timeInHours = Math.floor(time);
        const timeInMinutes = Math.round((time - timeInHours) * 60);

        return {
            hours: timeInHours,
            minutes: timeInMinutes
        };
    },
    // grouped data by date
    GroupByDate(data) {
        return data.reduce((acc, item) => {
            const date = item.time.split('T')[0];
            if (!acc[date]) {
                acc[date] = [];
            }
            acc[date].push(item);
            return acc;
        }, {});
    },
    convertTo24HourFormat(time) {

        if (!time) return null; // Handle null or undefined time
        const [timePart, modifier] = time?.split(' ');
        let [hours, minutes] = timePart?.split(':');
        hours = parseInt(hours, 10);

        if (modifier === 'PM' && hours !== 12) {
            hours += 12;
        }
        if (modifier === 'AM' && hours === 12) {
            hours = 0;
        }

        return new Date(`1970-01-01T${String(hours).padStart(2, '0')}:${minutes}:00`);
    },
    // grouped data by date api
    // DataGroupByDate(data) {
    //     return data.reduce((acc, item) => {
    //         const date = item?.metaData?.RequestDate.split('T')[0];
    //         if (!acc[date]) {
    //             acc[date] = [];
    //         }
    //         acc[date].push(item);
    //         return acc;
    //     }, {});
    // },
    DataGroupByDate(data) {

        return data.reduce((acc, item) => {
            const date = item?.metaData?.RequestDate?.split('T')[0];
            if (!acc[date]) {
                acc[date] = [];
            }
            acc[date].push(item);

            // Sort the array by PickupTime after adding a new item
            acc[date].sort((a, b) => {
                const timeA = this.convertTo24HourFormat(a.metaData?.PickupTime);
                const timeB = this.convertTo24HourFormat(b.metaData?.PickupTime);
                return timeA - timeB;
            });

            return acc;
        }, {});
    },

    SortObjectByDateKeys(obj, order) {
        const sortOrder = order ? 1 : -1;

        // Extract the keys and sort them
        const sortedKeys = Object.keys(obj).sort((a, b) => {
            return sortOrder * (new Date(a) - new Date(b));
        });

        // Create a new object with sorted keys
        const sortedObj = {};
        sortedKeys.forEach(key => {
            sortedObj[key] = obj[key];
        });

        return sortedObj;
    },
    sortGroupedDataByStatus(groupedData) {
        for (const date in groupedData) {
            groupedData[date].sort((a, b) => {
                if (a.status === 'accepted' && b.status !== 'accepted') {
                    return -1;
                }
                if (a.status !== 'accepted' && b.status === 'accepted') {
                    return 1;
                }
                return 0;
            });
        }
        return groupedData;
    },

    DynamicSort(array, field, order) {
        const sortOrder = order === 'desc' ? -1 : 1;

        array.sort((a, b) => {
            let valueA = a[field];
            let valueB = b[field];

            // Handle cases where the field may be null or undefined
            if (valueA === null || valueA === undefined) valueA = '';
            if (valueB === null || valueB === undefined) valueB = '';

            // Handle numeric or string comparison based on type
            if (typeof valueA === 'number' && typeof valueB === 'number') {
                return sortOrder * (valueA - valueB);
            } else {
                return sortOrder * valueA.toString().localeCompare(valueB.toString());
            }
        });

        return array;
    },
    FormatDate(date) {
        const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        const dayOfWeek = daysOfWeek[date.getDay()];
        const month = months[date.getMonth()];
        const day = date.getDate();
        const year = date.getFullYear();

        // Function to get the ordinal suffix for a day
        function getOrdinalSuffix(day) {
            if (day > 3 && day < 21) return 'th'; // Covers 11th, 12th, 13th, etc.
            switch (day % 10) {
                case 1: return 'st';
                case 2: return 'nd';
                case 3: return 'rd';
                default: return 'th';
            }
        }

        const dayWithSuffix = day + getOrdinalSuffix(day);

        return `${dayOfWeek}, ${month} ${dayWithSuffix}, ${year}`;
    },
    FormatToInternational(formattedNumber) {
        const numericValue = formattedNumber.replace(/\D/g, '');

        const internationalValue = `${numericValue}`;
        return internationalValue;
    },
    FormatToInternationalTest(formattedNumber) {
        const numericValue = formattedNumber.replace(/\D/g, '');

        const internationalValue = `+1${numericValue}`;
        return internationalValue;
    },
    DateFormator(date) {
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    },
    filterVolunteerData(data, searchTerm) {
        if (!searchTerm) return data;
        return data.filter(item =>
            item.SeniorName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.title.toLowerCase().includes(searchTerm.toLowerCase())
        );
    },
    isToday(date) {
        const today = new Date();
        return (
            date.getDate() === today.getDate() &&
            date.getMonth() === today.getMonth() &&
            date.getFullYear() === today.getFullYear()
        );
    },
    isTomorrow(date) {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        return (
            date.getDate() === tomorrow.getDate() &&
            date.getMonth() === tomorrow.getMonth() &&
            date.getFullYear() === tomorrow.getFullYear()
        );
    },
    isNextWeek(date) {
        const today = new Date();
        const nextWeek = new Date();
        nextWeek.setDate(today.getDate() + 7);
        return date > today && date <= nextWeek;
    },
    isNextMonth(date) {
        const today = new Date();
        const nextMonth = new Date();
        nextMonth.setMonth(today.getMonth() + 1);
        return date > today && date <= nextMonth;
    },
    isNextYear(date) {
        const today = new Date();
        const nextYear = new Date();
        nextYear.setFullYear(today.getFullYear() + 1);
        return date > today && date <= nextYear;
    },
    parseDate(dateString) {
        return new Date(dateString);
    },
    trackWelcome() {
        let selectedItems = localStorage.getItem('selectedItems') ? JSON.parse(localStorage.getItem('selectedItems')) : null;
        let selectedSchedule = localStorage.getItem('selectedSchedule') ? JSON.parse(localStorage.getItem('selectedSchedule')) : null;
        let FinalSchedule = localStorage.getItem('FinalSchedule') ? JSON.parse(localStorage.getItem('FinalSchedule')) : null;

        if (!selectedItems?.length) {
            return "/welcome"
        } else if (!selectedSchedule?.length) {
            return "/time"
        } else if (!FinalSchedule?.length) {
            return "/days"
        } else {
            return "/meal"
        }
    },
    // Helper function to format the time
    formatTime(date) {
        let hours = date.getHours();
        let minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // If hour is 0, set it to 12 (for 12 AM)
        minutes = minutes < 10 ? '0' + minutes : minutes; // Add leading 0 if needed
        return `${hours}:${minutes} ${ampm}`;
    },
    formatTo12Hour(timeStr) {
        const [hourStr, minuteStr] = timeStr.split(":");
        let hour = parseInt(hourStr, 10);
        const minute = minuteStr.padStart(2, '0');
        const period = hour >= 12 ? "PM" : "AM";

        hour = hour % 12 || 12; // Convert 0 to 12, and 13-23 to 1-11

        return `${hour}:${minute} ${period}`;
    },
    formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        return [year, month, day].join('-');
    },
    getLocalStorageSize(key) {
        // Get the data stored under the key
        const data = localStorage.getItem(key);
        if (!data) {
            const kb = 0
            const mb = 0
            const bytes = 0
            return {
                bytes,
                kb,
                mb,
            };
        }
        const bytess = new Blob([data]).size;
        const kbs = bytess / 1024;
        const mbs = bytess / (1024 * 1024);
        const kb = kbs.toFixed(2)
        const mb = mbs.toFixed(2)
        const bytes = bytess.toFixed(2)
        return {
            bytes,
            kb,
            mb,
        };
    },
    // getAppData() {
    //     try {
    //         let userInfo = AuthService.getAuthDataByName("userToken")
    //         if (userInfo) {
    //             let currentCenter = userInfo?.centerInfo?.[0]
    //             if (currentCenter) {
    //                 return currentCenter
    //             }
    //         }
    //         return { centerName: "My Senior Center", centerLogURI: "Assets/icons/msc_heart.png" }
    //     } catch (error) {
    //         console.log(error)
    //     }
    // },
    getAppData() {
        try {
            let hostName = window.location.hostname;
            if (hostName !== constant?.driversDomain) {

                let centerInfo = AuthService.getAuthDataByName("centerInfo")
                let id = AuthService.getAuthDataByName('gsid')
                if (centerInfo) {
                    let currentCenter = centerInfo?.find(x => x.gsid === id)
                    if (currentCenter) {
                        return currentCenter
                    }
                }
                return { centerName: "My Senior Center", centerLogoURI: "Assets/icons/msc_heart.png" }
            } else {
                let appInfo = AuthService.getAppData();
                if (appInfo) {
                    return { centerName: appInfo?.AppName, centerLogoURI: appInfo?.Logo };
                } else {
                    return { centerName: "My Senior Center", centerLogoURI: "Assets/icons/msc_heart.png" };
                }
            }
        } catch (error) {
            console.log(error)
        }
    },
    addSuffixToUrl(url) {
        const dotIndex = url.lastIndexOf(".");
        if (dotIndex === -1) return url; // No extension found
        return `${url.slice(0, dotIndex)}-T${url.slice(dotIndex)}`;
    },
    // addSuffixToUrl: async (url) => {
    //     const dotIndex = url.lastIndexOf(".");
    //     if (dotIndex === -1) return url;

    //     const modifiedUrl = `${url.slice(0, dotIndex)}-T${url.slice(dotIndex)}`;

    //     try {
    //         const res = await fetch(modifiedUrl, { method: "HEAD" });
    //         return res.ok ? modifiedUrl : url;
    //     } catch {
    //         return url;
    //     }
    // },
    uniqueById(data) {
        const uniqueData = data.reduce((acc, current) => {
            acc[current.seniorID] = current;
            return acc;
        }, {});

        return Object.values(uniqueData);
    },
    // addMealIds(data) {
    //     const mealMap = {};
    //     const firstEntryMap = {};
    //     const nameMap = {};

    //     data.forEach(item => {
    //         const { SeniorID, MealId, MealName } = item;

    //         // Store first appearance
    //         if (!mealMap[SeniorID]) {
    //             mealMap[SeniorID] = [];
    //             nameMap[SeniorID] = new Set();
    //             firstEntryMap[SeniorID] = item;
    //         }

    //         // Track MealId and mealName
    //         mealMap[SeniorID].push(MealId);
    //         if (MealName) {
    //             nameMap[SeniorID].add(MealName);
    //         }
    //     });
    //     console.log(mealMap)
    //     console.log(firstEntryMap)
    //     console.log(nameMap)

    //     return Object.keys(mealMap).map(SeniorID => {
    //         const first = firstEntryMap[SeniorID];
    //         const mealNames = Array.from(nameMap[SeniorID]);

    //         return {
    //             ...first,
    //             MealIds: mealMap[SeniorID],
    //             ...(mealNames.length > 1 && { mealNames }),
    //         };
    //     });
    // }
    addMealIds(data) {
        const seen = new Set();
        const mealMap = {};
        const nameMap = {};
        const result = [];

        for (const item of data) {
            const { SeniorID, MealId, MealName } = item;

            if (!seen.has(SeniorID)) {
                seen.add(SeniorID);
                mealMap[SeniorID] = [];
                nameMap[SeniorID] = new Set();
                result.push(item); // push the first appearance in order
            }

            mealMap[SeniorID].push(MealId);
            if (MealName) {
                nameMap[SeniorID].add(MealName);
            }
        }

        return result.map(first => {
            const SeniorID = first.SeniorID;
            const mealNames = Array.from(nameMap[SeniorID]);

            return {
                ...first,
                MealIds: mealMap[SeniorID],
                ...(mealNames.length > 1 && { mealNames }),
            };
        });
    },
    createSeniorId(id) {
        return id - 1
    },
    groupAndSortRequestsByDateDesc(data) {
        // Step 1: Group by RequestDate
        const grouped = data.reduce((acc, curr) => {
            const date = curr.RequestDate.split('T')[0];
            if (!acc[date]) acc[date] = [];
            acc[date].push(curr);
            return acc;
        }, {});

        // Step 2: Sort dates in descending order
        const sortedDates = Object.keys(grouped).sort((a, b) => new Date(b) - new Date(a));

        // Step 3: Return final result
        return sortedDates.map(date => ({
            date,
            requests: grouped[date]
        }));
    },
    shouldShowPopup() {
        const lastShown = localStorage.getItem('ackPopupLastShown');
        const today = new Date().toISOString().split('T')[0]; // e.g., "2025-06-25"

        return lastShown !== today;
    },
    locationFormat(location) {
        let locationString = `${location?.address ? `${location.address}, ` : ''}${location?.addressLine2 ? `${location.addressLine2}, ` : ''}${location?.city ? `${location.city}, ` : ''}${location?.state ? `${location.state}, ` : ''}${location?.zip ? `${location.zip}` : ''}`;

        return locationString;
    },
    formatMinutes(minutes) {
        const duration = intervalToDuration({ start: 0, end: minutes * 60 * 1000 });
        const hours = duration.hours || 0;
        const mins = duration.minutes || 0;

        if (hours > 0) {
            return `${hours}h ${mins}min`;
        } else {
            return `${mins}min`;
        }
    },


    checkRideCancelled(e) {
        let seniorList = [...e?.requestsOn, ...e?.requestsOff];
        if (seniorList?.length == 0) {
            return false;
        }
        let filterSeniorList = seniorList?.filter(z => z?.requestStatus !== "noshow" && z?.requestStatus !== "cancelled");
        return filterSeniorList?.length > 0 ? false : true;
    },
    // playAudio: async (path) => {
    //     try {
    //         const AudioContext = window.AudioContext || window.webkitAudioContext;
    //         const audioContext = new AudioContext();

    //         // iOS Safari often starts in "suspended"
    //         if (audioContext.state === "suspended") {
    //             await audioContext.resume();
    //         }

    //         const response = await fetch(path);
    //         const arrayBuffer = await response.arrayBuffer();
    //         const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

    //         const source = audioContext.createBufferSource();
    //         source.buffer = audioBuffer;
    //         source.connect(audioContext.destination);
    //         source.start(0);

    //         return true; // success
    //     } catch (error) {
    //         console.error("Error playing audio:", error);
    //         return false; // failed
    //     }
    // },

    playAudio: async (path) => {
        try {
            const context = getAudioContext();
            // iOS often needs this after returning from background
            if (context.state === "suspended") {
                await context.resume();
            }

            const response = await fetch(path);
            const arrayBuffer = await response.arrayBuffer();
            const audioBuffer = await context.decodeAudioData(arrayBuffer);

            const source = context.createBufferSource();
            source.buffer = audioBuffer;
            source.connect(context.destination);
            source.start(0);

            return true;
        } catch (error) {
            console.error("Error playing audio:", error);
            return false;
        }
    },
    mergeSeniorsWithCards: (seniors) => {
        let cards = JSON.parse(localStorage.getItem("KayTags"))
        const cardMap = Object.fromEntries(cards.map(c => [c.seniorID, c.cardID]));

        // Merge
        return seniors.map(senior => ({
            ...senior,
            cardID: cardMap[senior.seniorID] || null
        }));
    },
    getKeyTagBySeniorId: (seniorId) => {
        let cards = JSON.parse(localStorage.getItem("KayTags")) || [];
        if (cards && cards.length > 0) {
            let card = cards.find(c => c.seniorID === seniorId);
            return card ? card.cardID : null;
        }
        return null;
    },
    getLocalStorageValue: (key, defaultValue = null) => {
        const value = localStorage.getItem(key);
        if (value && value !== "undefined" && value !== "") {
            try {
                return JSON.parse(value);
            } catch (e) {
                console.error(`Failed to parse ${key}:`, e.message, value);
                localStorage.removeItem(key); // Clear invalid data
                return defaultValue;
            }
        }
        return defaultValue;
    },
    attachSeniorsToRoutes: (routes = [], seniorList = []) => {
        // If routes is not an array, return empty array
        if (!Array.isArray(routes)) return [];

        // Ensure seniorList is always an array
        const safeSeniorList = Array.isArray(seniorList) ? seniorList : [];

        // Group seniors by RouteID
        const grouped = safeSeniorList.reduce((acc, senior) => {
            if (!senior || senior.RouteID == null) return acc;

            if (!acc[senior.RouteID]) {
                acc[senior.RouteID] = [];
            }

            acc[senior.RouteID].push(senior);
            return acc;
        }, {});

        // Attach seniors to routes
        return routes.map(route => ({
            ...route,
            Seniors: grouped[route.RouteID] || []
        }));
    }


}

export default Helpers;